import { type MouseEvent, useCallback } from "react";
import { useDispatch } from "react-redux";
import { trackUnitsInteraction } from "~/feature/Analytics/ga/ga";
import type { UnitMode } from "~/feature/UnitMode/UnitMode";
import { useUnitMode } from "~/feature/UnitMode/useUnitMode";
import type { GAPageType } from "./UnitModeToggle";
import { changeUnitModeThunk } from "~/feature/UserPreferences/userPreferencesSlice";

export const useReduxUnitMode = (page: GAPageType, onChange?: (unitMode: UnitMode) => void) => {
  const value = useUnitMode();
  const dispatch = useDispatch();
  const handleOnChange = useCallback(
    (unitMode: UnitMode) => {
      dispatch(changeUnitModeThunk(unitMode));
      trackUnitsInteraction(page, unitMode);
      onChange?.(unitMode);
    },
    [dispatch, page, onChange],
  );
  const onClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      const unitMode = (e.target as HTMLElement).getAttribute("value")! as UnitMode;
      handleOnChange(unitMode);
    },
    [handleOnChange],
  );
  return {
    value,
    onClick,
    onChange: handleOnChange,
  };
};
